import { StaticQuery, graphql } from 'gatsby';
import Footer from './layouts/footer';
import Navbar from './layouts/navBar';

function Layout({ children, pageInfo = {}, showDisclaimer, hideNavItems, applyUrl, preventLogoLink }) {
    return (
        <StaticQuery
            query={graphql`
                query SiteTitleQuery {
                    site {
                        siteMetadata {
                            title
                        }
                    }
                }
            `}
            render={() => (
                <>
                    <Navbar
                        preventLogoLink={preventLogoLink}
                        pageInfo={pageInfo}
                        hideNavItems={hideNavItems}
                        applyUrl={applyUrl}
                    />
                    {children}
                    <Footer hideNavItems={hideNavItems} showDisclaimer={showDisclaimer} />
                </>
            )}
        />
    );
}

export default Layout;
